export const POST_TEMPLATE = 'POST_TEMPLATE';
export const RESET_TEMPLATE = 'RESET_TEMPLATE';
export const GET_TEMPLATE = 'GET_TEMPLATE';
export const DELETE_TEMPLATE = 'DELETE_TEMPLATE';
export const RESET_DELETE_TEMPLATE = 'RESET_DELETE_TEMPLATE';
export const GET_TEMPLATE_ID = 'GET_TEMPLATE_ID';
export const EDIT_TEMPLATE = 'EDIT_TEMPLATE';